import React from "react";


const Shortlink_instruction = () => {
    return(
        <div>
            <img className="img-fluid img-thumbnail" src='./Assets/instruction.png' alt="راهنمای دریافت جوابدهی آنلاین آزمایشگاه پارسی پل خودران pws.ir"></img>
        </div>
    );
}

export default Shortlink_instruction;